import TileGridContainer from 'features/tiles/tileGridContainer';
import { FC } from 'react';
import TileWithoutDefaultStyling from 'features/tiles/tileWithoutDefaultStyling';
import { useDispatch, useSelector } from 'react-redux';
import CopyToClipboard from 'common/components/copy-to-clipboard/copy-to-clipboard';

export const HelpPage: FC = () => {
  const dispatch = useDispatch();

  return (
    <TileGridContainer>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full  grow basis-full mt-3">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 mb-1 mt-2 ml-2">
            Documentation
          </h2>
          <div className="flex items-center ml-2">
            <hr className="border-t-1 border-neutral-200 flex-grow" />
          </div>
          <div className="text-sm mb-1 mt-2 ml-2">
            <p>
              To get started please follow the set-up instructions in our
              documentation guide:
            </p>
            <p>
              {' '}
              <a
                href="https://ruler-documentation.readme.io/docs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-100"
              >
                {' '}
                https://ruler-documentation.readme.io/docs
              </a>
            </p>
          </div>
        </section>
      </TileWithoutDefaultStyling>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full  grow basis-full mt-3">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 mb-1 mt-2 ml-2">
            Readme
          </h2>
          <div className="flex items-center ml-2">
            <hr className="border-t-1 border-neutral-200 flex-grow" />
          </div>
          <div className="text-sm mb-1 mt-2 ml-2">
            <p>
              You can find more information about how to use Ruler in our Help
              Centre:
            </p>
            <p>
              {' '}
              <a
                href="https://help.ruleranalytics.com/en/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-100"
              >
                {' '}
                https://help.ruleranalytics.com/en/
              </a>
            </p>
          </div>
        </section>
      </TileWithoutDefaultStyling>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full  grow basis-full mt-3">
        <section className="mx-6 my-6">
          <h2 className="text-primary-700 text-l leading-7 mb-1 mt-2 ml-2">
            Support
          </h2>
          <div className="flex items-center ml-2">
            <hr className="border-t-1 border-neutral-200 flex-grow" />
          </div>
          <div className="text-sm mb-1 mt-2 ml-2">
            <p>
              If you need any help please
              <a
                href="https://www.ruleranalytics.com/contact/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-100"
              >
                {' '}
                contact us
              </a>
            </p>
          </div>
        </section>
      </TileWithoutDefaultStyling>
    </TileGridContainer>
  );
};
